import { ReactNode } from "react";

export const AuthLayout = ({ children }: { children: ReactNode }) => {
  return <div className="flex min-h-screen items-center justify-center">{children}</div>;
};
